<template>
  <span class="base-pill" :class="classActive">
    <slot />
  </span>
</template>

<script>
export default {
  name: 'BasePill',
  props: {
    active: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    classActive() {
      return {
        'base-pill_active': this.active,
        'base-pill_inactive': !this.active
      }
    }
  }
}
</script>

<style>
  .base-pill {
    border-radius: 12px;
    font-size: 12px;
    text-transform: uppercase;
    color: #fff;
    padding: 3px 10px;
    display: flex;
    align-items: center;
  }

  .base-pill_active {
    background: #42dda1;
  }

  .base-pill_inactive {
    background: #dd4242;
  }

</style>